import { SpinningProfiles } from '@components/icons/SpinningProfiles'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useStepper } from '@/hooks/useStepper'
import { CONSULTATION_STEPS, STEP_STEPPER } from '@/types/consultation'

export const Matching = () => {
  const { t } = useTranslation()
  const { updateStep } = useStepper()

  useEffect(() => {
    updateStep(STEP_STEPPER[CONSULTATION_STEPS.MATCHING])
  }, [])

  return (
    <div className="flex flex-1 flex-col items-center gap-6 p-4" data-testid="matching-container">
      <h2 className="text-center text-2xl font-bold text-primary">{t('matching')}</h2>

      <SpinningProfiles />

      <span>{t('match.one_minute')}</span>
    </div>
  )
}
